<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.682" height="14.512" viewBox="0 0 13.682 14.512">
    <path class="a"
          d="M11.6,5.732,7.046,10.288a1.487,1.487,0,0,0,2.1,2.1l4.557-4.557A2.974,2.974,0,1,0,9.5,3.628L4.943,8.185a4.461,4.461,0,0,0,6.309,6.309l4.557-4.557"
          transform="translate(-3.011 -1.914)"
          fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25px"
    />
  </svg>
</template>
